import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import AbroadCallsTroubleshootingWizardBlockData from "../../../Models/Content/AbroadCallsTroubleshootingWizardBlockData";
import AbroadCallsTroubleshootingWizard from "./AbroadCallsTroubleshootingWizard";

export default class AbroadCallsTroubleshootingWizardBlock extends EpiComponent<AbroadCallsTroubleshootingWizardBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <AbroadCallsTroubleshootingWizard context={this.getContext()} contentData={this.props.data} />;  
  }
}
